/** Healthie's placeholder is a broken-image asset, not a clinician photo. */
export function renderableClinicianPhoto(
  src: string | null | undefined,
): string | null {
  if (!src) return null;
  return src.includes('/original/missing.png') ? null : src;
}

export function clinicianInitials(name: string): string {
  return name
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
}
